import { Components, Theme } from '@mui/material/styles';

const dropDownTheme: Components<Theme>['MuiSelect'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "&.MuiOutlinedInput-root": {
        background: theme.palette.neutralWhite,
        color: theme.palette.black,
        '&.Mui-disabled:hover .MuiOutlinedInput-notchedOutline, &.Mui-disabled .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.grey[100]
        },
        "& fieldset, &:hover fieldset, &.Mui-focused fieldset": {
          borderColor: theme.palette.clearBlue,
          borderWidth: "3px",
          borderRadius: 0,
        },
        '&.small': {
          "& fieldset, &:hover fieldset, &.Mui-focused fieldset": {
            borderWidth: "2px",
          },
          '& .MuiSelect-icon': {
            right: '2px'
          }
        }
      }
    }),
  },
};

export default dropDownTheme;
